import {ContractDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CONTRACT';

export async function createContract(
    userData: Record<string, string>,
    newContract: Record<string, any>
) {

    try {
        return await ContractDao.createContract(userData.userToken, newContract);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création d\' contrat',
            error: error
        });
    }
}
